export default {
	'total-net': 'Net toplam',
	'show-all-journal': 'Tüm yevmiyeleri göster',
	'enter-quantity': 'Miktarı giriniz',
	'enter-item-by-barcode': 'Barkoduna göre giriniz',
	'paper-document': 'Kağıt belge',
	'addition-item': 'Ek Ürün',
	'the-net-invoice-must-be-zero-and-this-requires-zeroing-all-financial-fields': 'Net fatura sıfır olmalıdır ve bu da tüm finansal alanların sıfırlanmasını gerektirir',

	'confirm-user': 'Kullanıcıyı onayla'
}